import { render, staticRenderFns } from "./AiTranslationDialog.vue?vue&type=template&id=d9523a40&scoped=true&"
import script from "./AiTranslationDialog.vue?vue&type=script&lang=ts&"
export * from "./AiTranslationDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AiTranslationDialog.vue?vue&type=style&index=0&id=d9523a40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9523a40",
  null
  
)

export default component.exports